// src/components/RPA/buttons/AnalyzeFinancialStatementButton.js
import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API || 'http://localhost:8000';

export default function AnalyzeFinancialStatementButton({ docId, onDone, disabledHint }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!docId) return;
    
    setLoading(true);
    try {
      const res = await axios.post(
        `${API_URL}/admin/rpa/analyze-financial-statement`,
        { docId },
        { withCredentials: true }
      );
      
      console.log('[FS_ANALYZE_BTN] Success:', res.data);
      if (onDone) onDone();
    } catch (err) {
      console.error('[FS_ANALYZE_BTN] Failed:', err);
      alert(err.response?.data?.message || 'Financial statement analysis failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading || !!disabledHint}
      title={disabledHint || 'Analyze financial statement'}
      style={{
        background: loading ? '#9ca3af' : (disabledHint ? '#fca5a5' : '#10b981'),
        color: 'white',
        border: 'none',
        padding: '4px 8px',
        borderRadius: 4,
        fontSize: 11,
        cursor: loading || disabledHint ? 'not-allowed' : 'pointer',
        fontWeight: 500
      }}
    >
      {loading ? 'Analyzing…' : 'Analyze FS'}
    </button>
  );
}